/**
 * Pure helpers for Ask Addy post-answer follow-up suggestions.
 */

/**
 * Collect recent user question texts from chat messages.
 * @param {Array<{type?: string, message?: string}>} messages
 * @param {number} [limit=4]
 * @returns {string[]}
 */
export function extractPreviousUserQuestions(messages = [], limit = 4) {
  if (!Array.isArray(messages) || limit <= 0) {
    return [];
  }

  return messages
    .filter(
      (message) =>
        message?.type === "user" &&
        typeof message.message === "string" &&
        message.message.trim().length > 0,
    )
    .map((message) => message.message.trim())
    .slice(-limit);
}

/**
 * Decide whether a completed Ask Addy turn should request follow-ups.
 * @param {object} params
 * @param {boolean} params.encounteredError
 * @param {boolean} params.clarificationHandled
 * @param {boolean} params.aborted
 * @param {string} params.fullResponse
 * @returns {boolean}
 */
export function shouldGenerateFollowUps({
  encounteredError = false,
  clarificationHandled = false,
  aborted = false,
  fullResponse = "",
} = {}) {
  if (encounteredError || clarificationHandled || aborted) {
    return false;
  }

  return typeof fullResponse === "string" && fullResponse.trim().length >= 40;
}
